import { render } from "./ShapingTarget.vue?vue&type=template&id=04c92096&scoped=true"
import script from "./ShapingTarget.vue?vue&type=script&lang=js"
export * from "./ShapingTarget.vue?vue&type=script&lang=js"

import "./ShapingTarget.vue?vue&type=style&index=0&id=04c92096&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c92096"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
